import React, { useEffect, useState } from "react";
import API from '../Services/ProductType'
import APIS from '../Services/SalesTab'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ButtonColorList from '../Components/ButtonColor'
import moment from "moment";
import APISS from '../Services/Location'
import DisplayOrder from "../Components/DisplayOrder";

const ProductTypeList = () => {
    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });

    const [name, setName] = useState("")
    const [salesTab, setSalesTab] = useState([])
    const [buttonColor, setButtonColor] = useState("")
    const [displayOrder, setDisplayOrder] = useState([])
    const [location, setLocation] = useState([])
    const [trackInventory, setTrackInventory] = useState("")
    const [isCombo, setISCombo] = useState("")
    const [isShowtoCustomer, setIsShowtoCustomer] = useState("")
    const [selectSalesTab, setSelectSalesTab] = useState("")
    const [error, setError] = useState({});
    const [productList, setProductList] = useState([])
    const perPage = 10
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState([])
    const [isRecipe, setIsRecipe] = useState("")
    const [search, setSearch] = useState("")
    const [waiverRequired, setWaiverRequired] = useState("")
    const [createdAt, setCreatedAt] = useState("");
    const [status, setStatus] = useState("");

    const [centerName, setCenterName] = useState("");
    const [salesTabName, setSalesTabName] = useState("");
    const [displayOrder1, setDisplayOrder1] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("");
    const [enableParty, setEnableParty] = useState("")

    useEffect(() => {
        getProductList();
    }, [currentPage]);

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectSalesTab(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };

    const handleChange1 = (e) => {
        const value = e.target.value;
        // console.log("value data id",value)
        setSelectedLocation(value);
        getSalesTab(value)
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };


    const validateFields = () => {
        const errors = {};
        if (!name.trim()) errors.name = "Name is required";
        // if (!displayOrder) {
        //     errors.displayOrder = "Display order is required";
        // }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "selectSalesTab":
                setSelectSalesTab(value);
                break;
            case "selectedLocation":
                setSelectedLocation(value);
                break;
            case "displayOrder":
                setDisplayOrder(value);
                break;
            case "isRecipe":
                setIsRecipe(value);
                break;
            default:
                break;
        }
    };
    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const getSalesTab = async (location) => {
        try {
            if (location === "Select") {
                // console.log('ddd')
                setSalesTab([]);
                return;
            }
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 10,
                pageNumber: 1,
                search: location,
            });
            setSalesTab(response?.data?.data || []);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };


    const getProductList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage,
            };

            if (search) {
                payload.search = search;
            }
            else if (selectedLocation && selectedLocation !== "" && selectedLocation.length > 0) {
                payload.search = selectedLocation;
            }

            if (selectedStatus !== "") {
                payload.is_active = selectedStatus;
            }
            if (
                selectedLocation &&
                selectedLocation !== "" &&
                Array.isArray(selectedLocation) &&
                selectedLocation.length > 0
            ) {
                payload.search = selectedLocation;
            }

            const response = await API.Get_Product_Type(payload);
            setProductList(response?.data?.data);
            setTotalRecords(response?.data?.totalCount);
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Unauthorized access! Redirecting to login.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };



    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (fieldName === "search") {
            setSearch(value);
            if (value.trim() === "") {
                setCurrentPage(1);
                getProductList(1);
            }
        }
    };
    const handleSearch = () => {
        // console.log('selectedStatus', selectedStatus);
        setCurrentPage(1);
        getProductList();
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getProductList();
        }
    };


    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeProductStatus(id, updatedStatus);
            if (response.status === 200) {
                setProductList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Product Type ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                // setTimeout(() => window.location.reload(), 5000);
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
                // setTimeout(() => window.location.reload(), 10000);
            }
        } catch (error) {
            console.log("Error in status toggle:", error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            toast.error("Failed to update the status. Please try again.");
            // setTimeout(() => window.location.reload(), 10000);
        }
    };

    const handleGetData = async (productId) => {
        try {
            const response = await API.Get_Product_Type({ id: productId });
            const fetchedData = response?.data?.data[0];
            // console.log("fetchdata", fetchedData)
            if (fetchedData) {
                setHighlight(true);
                setId(fetchedData.id);
                setName(fetchedData?.name);
                setButtonColor(fetchedData?.button_color_id);
                setDisplayOrder(fetchedData?.display_order);
                setSelectedLocation(fetchedData?.location_id);
                setSelectSalesTab(fetchedData?.sale_tab_id);
                setTrackInventory(fetchedData?.track_inventory);
                setISCombo(fetchedData?.is_combo);
                setIsShowtoCustomer(fetchedData?.show_to_customer)
                getSalesTab(fetchedData?.location_id);
                setWaiverRequired(fetchedData?.is_waiver_required);
                setCreatedAt(fetchedData?.createdAt);
                setStatus(fetchedData?.is_active);
                setCenterName(fetchedData?.location_name);
                setSalesTabName(fetchedData?.sales_tab_name)
                setDisplayOrder1(fetchedData?.display_order)

                let weekdaysObject = {};
                const weekdaysArray = fetchedData?.week_list
                    ? fetchedData?.week_list.split(",").map(day => day.trim())
                    : [];

                if (weekdaysArray.includes("All Days")) {
                    // All checkboxes true
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = true;
                        return acc;
                    }, {});
                } else {
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = weekdaysArray.includes(day);
                        return acc;
                    }, {});
                }

                setWeekdays(weekdaysObject);
                setIsEditing(true);

            } else {
                toast.error("Failed to fetch product Type details.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const handleWeekdayChange1 = (day) => {
        setWeekdays((prevWeekdays) => ({
            ...prevWeekdays,
            [day]: !prevWeekdays[day],
        }));
    };
    const updateProductData = async () => {
        // console.log('aaaaaaaaaaaaaaaa');
        // const selectedDays = Object.keys(weekdays)
        //     .filter((day) => weekdays[day])
        //     .join(", ");


        const selectedDaysArr = Object.keys(weekdays).filter(day => weekdays[day]);
        const weekList = selectedDaysArr.length === 7 ? "All Days" : selectedDaysArr.join(", ");

        // const weekList = selectedDays || "All Days";
        const updatedTrackInventory = Boolean(trackInventory);
        const updatedIsCombo = Boolean(isCombo);
        const updatedIsShowCutomer = Boolean(isShowtoCustomer);
        const updatedIsRecipe = Boolean(isRecipe);
        const updateWaiverRequred = Boolean(waiverRequired)
        if (!selectSalesTab || selectSalesTab === "Select") {
            toast.error("Sales Tab is required");
            return;
        }

        // if (!displayOrder || displayOrder === "Select") {
        //     toast.error("Display Order is required");
        //     return;
        // }
        try {
            const payload = {
                name,
                sale_tab_id: selectSalesTab,
                // button_color_id: buttonColor,
                display_order: displayOrder || displayOrder1,
                //display_order: displayOrder,
                location_id: selectedLocation,
                track_inventory: updatedTrackInventory,
                is_combo: updatedIsCombo,
                is_recipe: updatedIsRecipe,
                week_list: weekList,
                show_to_customer: updatedIsShowCutomer,
                is_waiver_required: updateWaiverRequred,
                //is_party: 
            };
          //  console.log('payload list', payload);
            const response = await API.updateProductType(id, payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Product Type Status Updated Successfully!");
                getProductList();
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Product Type. Please try again.");
            }
        } catch (error) {
            console.error("Error updating product:", error);
            toast.error("An unexpected error occurred. Please try again later.");
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };


    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updateProductData();

    };


    useEffect(() => {
        bindLocation()
    }, [])

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            setError("Failed to fetch locations.");
            console.error(error);
        }
    };


    return (
        <div >

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Product Type</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="ddSalesType" className="form-label">
                                    Search By
                                </label>
                                <input type="text" className="form-control" placeholder="Search by Name"
                                    value={search}
                                    onChange={(e) => handleFieldChange1(e, "search")}
                                />
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        Center
                                    </label>
                                    <select
                                        className="form-select"
                                        id="ddSalesType"
                                        value={selectedLocation}
                                        onChange={(e) => setSelectedLocation(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {location.map((item) => (
                                            <option key={item.id} value={item.name}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        Status
                                    </label>
                                    <select
                                        className="form-select"
                                        id="ddSalesType"
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center Name</th>
                                        <th>Sales Tab</th>


                                        <th>Is Combo</th>
                                        <th>Week List</th>
                                        <th>Waiver Required</th>
                                        <th>Show to Customer</th>

                                        {/* <th>Button Color</th> */}
                                        <th>Track Inventory</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productList.map((item, index) => (

                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {/* <button className="btn btn-primary btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '} */}
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}>
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.location_name}</td>
                                            <td>{item.sales_tab_name}</td>

                                            <td>{item.is_combo ? "Yes" : "No"}</td>
                                            <td>{item.week_list}</td>
                                            <td>{item.is_waiver_required ? "Yes" : "No"}</td>
                                            <td>{item.show_to_customer ? "Yes" : "No"}</td>
                                            <td>{item.track_inventory ? "Yes" : "No"}</td>
                                            {/* <td>{item.button_color_name}</td> */}
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {productList.length > 0 && (
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                            >
                                                {page === "..." ? (
                                                    <span className="page-link">...</span>
                                                ) : (
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                )}
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Product Type</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-1">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="txtname" className="form-label">
                                                Name <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}
                                            />
                                            {error.name && <small className="text-danger">{error.name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Center <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select className="form-select"
                                                id="ddSalesType"
                                                value={selectedLocation}
                                                onChange={handleChange1}
                                            >
                                                <option>Select</option>
                                                {Array.isArray(location) ? location.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                )) : null}
                                            </select>
                                            {error.location && <small className="text-danger">{error.location}</small>}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="ddSalesType" className="form-label">
                                                Sales Tab <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select className="form-select"
                                                id="ddSalesType"
                                                value={selectSalesTab}
                                                // onChange={(e) => handleFieldChange(e, "salesTab")}
                                                onChange={handleChange} >
                                                <option>Select</option>
                                                {salesTab.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tab_name}
                                                    </option>
                                                ))}
                                            </select>
                                            {error.salesTab && <small className="text-danger">{error.salesTab}</small>}
                                        </div>
                                    </div>

                                </div>
                                <div className="row mb-3">

                                    <div className="col-md-3">
                                        <DisplayOrder
                                            selectedDisplayOrder={displayOrder}
                                            setSelectedDisplayOrder={(color) => {
                                                setDisplayOrder(color);
                                                if (color.trim()) {
                                                    setError((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.buttonColor;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="ticketInventory"
                                                className="form-label"
                                            >
                                                Track Inventory
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="ticketInventory"
                                                    checked={trackInventory} onChange={() => setTrackInventory(!trackInventory)}
                                                />
                                                <label
                                                    htmlFor="ticketInventory"
                                                    className="form-check-label"
                                                >
                                                    Enable Inventory
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="isCombo" className="form-label">
                                                Is Combo
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isCombo"
                                                    checked={isCombo} onChange={() => setISCombo(!isCombo)}
                                                />
                                                <label htmlFor="isCombo" className="form-check-label">
                                                    Enable Combo
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="isShowtoCustomer" className="form-label">
                                                {/* Show To Customer */}
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isshowtocustomer"
                                                    checked={isShowtoCustomer} onChange={() => setIsShowtoCustomer(!isShowtoCustomer)}
                                                />
                                                <label htmlFor="isShowtoCustomer" className="form-check-label">
                                                    Show to Customer
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="isWaiver" className="form-label">
                                                {/* Waiver Required */}
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isWaiver"
                                                    checked={waiverRequired} onChange={() => setWaiverRequired(!waiverRequired)}
                                                />
                                                <label htmlFor="isWaiver" className="form-check-label">
                                                    Waiver Required
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="isWaiver" className="form-label">
                                               
                                            </label>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="isParty"
                                                    checked={enableParty} onChange={() => setEnableParty(!enableParty)}
                                                />
                                                <label htmlFor="isWaiver" className="form-check-label">
                                                    Enable Party Booking
                                                </label>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="row mb-4">
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label className="form-label">Weekday List</label>
                                            <div className="d-flex flex-wrap">
                                                {allWeekdays.map((day) => (
                                                    <div className="form-check me-3" key={day}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input ms-1"
                                                            id={day}
                                                            checked={weekdays[day] || false}
                                                            onChange={() => handleWeekdayChange1(day)}
                                                        />
                                                        <label htmlFor={day} className="form-check-label">{day}</label>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    onClick={handleSubmit}
                                    type="button"
                                    className="btn btn-primary me-3"
                                >
                                    Submit
                                </button>

                                {/* <button className="btn btn-primary" onClick={handleUpdateMachine} >Update</button> */}
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Product Type Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">

                                <div className="card">
                                    <div className="card-body">

                                        <table className="table table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Sales Tab</th>
                                                    <th>Center Name</th>

                                                </tr>

                                                <tr>
                                                    <td>{name}</td>
                                                    <td>{salesTabName}</td>
                                                    <td>{centerName}</td>

                                                </tr>
                                                <tr>
                                                    <th>Track Inventory</th>
                                                    <th>Is Combo</th>
                                                    <th>Week List</th>

                                                </tr>
                                                <tr>
                                                    <td>{trackInventory ? "Yes" : "No"}</td>
                                                    <td>{isCombo ? "Yes" : "No"}</td>
                                                    <td>
                                                        {weekdays === "All Days"
                                                            ? "All Days"
                                                            : Object.entries(weekdays)
                                                                .filter(([day, isSelected]) => isSelected)
                                                                .map(([day]) => day)
                                                                .join(', ') || 'All Days'}
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <th>Waiver Required</th>
                                                    <th>Show to Customer</th>
                                                    <th>Status</th>
                                                </tr>
                                                <tr>
                                                    <td>{waiverRequired ? "Yes" : "No"}</td>
                                                    <td>{isShowtoCustomer ? "Yes" : "No"}</td>
                                                    <td>{status ? "Active" : "De-Activated"}</td>
                                                </tr>
                                                <tr>
                                                    {/* <th>Enable Party</th> */}
                                                    <th>Created Date</th>
                                                </tr>
                                                <tr>
                                                    {/* <td>{enableParty ? "True" : "False"}</td> */}
                                                    <td>{moment(createdAt).format("DD-MM-YYYY")}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <ToastContainer /> */}

        </div>
    );
};

export default ProductTypeList